import React, { FC, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  Button,
  Text,
  ModalBody,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../../../i18n';
import { Language } from '../../../../../types/Common';
import AdvisoryReportLanguagePicker from '@advisory-report/src/features/creation-flow/components/party/AdvisoryReportLanguagePicker';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onLanguageSelected: (language: Language) => void;
}

const AdvisoryReportLanguageModal: FC<Props> = ({
  isOpen,
  onClose,
  onLanguageSelected,
}) => {
  const { t } = useTranslation();
  const { userLang } = useLocale();
  const [selectedLang, setSelectedLang] = useState<Language>(
    userLang as Language,
  );
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t(`ADVISORY-REPORTS_CREATION-FLOW_LANGUAGE-MODAL_TITLE`)}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody as={VStack} align="stretch" spacing="4">
          <Text>
            {t('ADVISORY-REPORTS_CREATION-FLOW_LANGUAGE-MODAL_DESCRIPTION')}
          </Text>
          <AdvisoryReportLanguagePicker
            value={selectedLang}
            onChange={setSelectedLang}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="grayedGhost" mr={3} onClick={onClose}>
            {t('CLOSE')}
          </Button>
          <Button
            colorScheme="blue"
            onClick={() => {
              onLanguageSelected(selectedLang);
              onClose();
            }}
          >
            {t('COMPANY-SCAN_RECOMMENDATIONS_CREATE-ADVISORY-REPORT_TITLE')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AdvisoryReportLanguageModal;
